import { supabase } from '@/lib/supabase'
import type { ListSubscriptionsParams, ListSubscriptionsResult } from '../types'

export async function listSubscriptionsV2({
  search = '',
  status = '',
  page = 1,
  pageSize = 25,
}: ListSubscriptionsParams): Promise<ListSubscriptionsResult> {
  try {
    const { data, error } = await supabase.functions.invoke('admin-subscription-list-v2', {
      body: { search, status, page, pageSize } as any,
    })
    if (error) throw error
    const payload = Array.isArray(data) ? (data as any)[0] : (data as any)
    if (payload?.error) throw new Error(payload.error)
    const items = (payload?.items || []) as any[]
    const total = Number(payload?.total || items.length)
    return { items, total }
  } catch (e) {
    console.warn('listSubscriptionsV2 (admin) fallback:', e)
    return { items: [], total: 0 }
  }
}

